/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AutoUpdatedFirmReportZipModel = {
  readonly id?: number;
  readonly status_label?: AutoUpdatedFirmReportZipModel.status_label;
  readonly http_status?: AutoUpdatedFirmReportZipModel.http_status;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  version_id?: string | null;
  last_excel_export_update?: string | null;
  last_zip_file_update?: string | null;
  last_zip_error_message?: string | null;
  last_zip_error_at?: string | null;
  report_date?: string | null;
  firm: number;
};
export namespace AutoUpdatedFirmReportZipModel {
  export enum status_label {
    COMPLETED = 'Completed',
    IN_PROGRESS = 'In Progress',
    FAILED = 'Failed',
  }
  export enum http_status {
    '_200' = 200,
    '_202' = 202,
    '_500' = 500,
  }
}

